import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IFileOptions} from "../../../services/form-dialog.service";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

export const SHEET_DOWNLOAD_OPTIONS: IFileOptions[] = [
    {title: 'Excel', value: 'xlsx'},
    {title: 'CSV', value: 'csv'}
];

@Component({
    selector: 'sheet-download-format-menu',
    templateUrl: './sheet-download-format-menu.component.html',
    styleUrls: ['./sheet-download-format-menu.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        MatRadioGroup,
        MatRadioButton
    ]
})
export class SheetDownloadFormatMenuComponent implements OnInit {
    @Input() fileOptions: IFileOptions[];
    @Output() handleDownload: EventEmitter<string> = new EventEmitter();

    selectedValue: string;

    ngOnInit() {
        this.selectedValue = this.fileOptions?.[0]?.value;
    }

    downloadClicked() {
        if (this.selectedValue) {
            this.handleDownload.emit(this.selectedValue);
        }
    }
}
